module.exports = __webpack_public_path__ + "img/4.f1bab7ed.png";